import { render, staticRenderFns } from "./UngroupIcon.vue?vue&type=template&id=0a4e4b80"
import script from "./UngroupIcon.vue?vue&type=script&lang=js"
export * from "./UngroupIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports